<style>
.body {
    display: flex;
}
</style>

<template>
    <div class="m-0">
        <div class="row container mx-0 px-0">
            <div :class="'bg-'+ module.color" class="col-12 top-row">&nbsp;</div>
        </div>
        <div :class="'border-'+ module.color" class="row container body mx-0 px-0">
            <div class="col-sm-3 pt-2 pb-4 big-icon-block" :class="'bg-'+ module.color">
                <div :class="'module-icons-lg '+ module.icon"></div>
                <div class="w-100"></div>
                <div class="module-name-lg">{{ module.name }}</div>
            </div>
            <div class="col-sm-9 instruction-status">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            module: {
                required: true,
                type: Object
            },
        }
    }
</script>